import { newStorage } from './storage';

const announcementsTableStorage = newStorage('TABLE_ANNOUNCEMENTS');

export default announcementsTableStorage;
